import { Modal } from '@simplywallst/ui-core';
import type { BillingPeriod } from '../../constants';

interface Props {
  planName?: string;
  planInterval?: BillingPeriod;
  handleCloseModal: () => void;
}

const formatInterval = (interval: string): string => {
  return interval === 'year' ? 'Annual' : 'Monthly';
};
const formatPlan = (plan: string): string =>
  plan.charAt(0).toUpperCase() + plan.slice(1);

export const BillingSuccessModal = ({
  planName,
  planInterval,
  handleCloseModal,
}: Props) => {
  return (
    <Modal
      data-cy-id="modal-success"
      title="Success"
      onPrimaryClick={handleCloseModal}
      primaryLabel="OK"
      onSecondaryClick={handleCloseModal}
    >
      <p data-cy-id="billing-modal-desc">
        {planName && planInterval
          ? `You are now subscribed to ${formatPlan(planName)} ${formatInterval(
              planInterval
            )}.`
          : `You are now subscribed`}
      </p>
    </Modal>
  );
};
